import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { TARA_CAN_CHAT_API } from '../../constants/central-api';
import {
  setCanChat,
  setCurrentTokenCount,
} from '../../../store/reducers/chatSlice';
import {
  setIsPaymentPopupOpen,
  setPaymentPopupTemporaryMessage,
} from '../../../store/reducers/uiSlice';
import { setMessage } from '../../../store/reducers/appSlice';
import { t } from 'i18next';
import { NavigateFunction } from 'react-router-dom';

export default async function check_tara_can_chat_status_api_call(
  navigate?: NavigateFunction,
  toggleNoIntegrationsPopupModal?: () => void
) {
  const shopSlug = store.getState().user?.company?.shop_slug;
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  let sellerToken: string;
  if (isWhiteLabel) {
    sellerToken = accessToken?.currentWhiteLabelSellerToken;
  } else {
    sellerToken = accessToken?.sellerToken;
  }

  const requestInfo: RequestInfo = {
    url: `${TARA_CAN_CHAT_API}?shop_slug=${shopSlug}`,
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'CHECK_TARA_CAN_CHAT_STATUS_API';
  const customMsg = 'Successfully checked Tara can chat status.';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false,
    true
  );
  const response = res?.data;

  if (res.actionType === actionType && response?.data !== null) {
    const currentTokenCount =
      typeof response?.data?.current_token_count === 'number' &&
      !Number.isNaN(response?.data?.current_token_count)
        ? response?.data?.current_token_count
        : 0;
    store.dispatch(setCurrentTokenCount(currentTokenCount));
    if (response.success === true && response?.data?.can_chat === true) {
      store.dispatch(setCanChat(true));
      return true;
    } else if (response?.data?.status) {
      store.dispatch(setCanChat(false));
      if (response?.data?.status === 'subscription_required') {
        store.dispatch(
          setPaymentPopupTemporaryMessage(
            `⚠️ ${t('Tara-SubscriptionRequired')}`
          )
        );
        store.dispatch(setIsPaymentPopupOpen(true));
      } else if (response?.data?.status === 'upgrade_required') {
        store.dispatch(
          setPaymentPopupTemporaryMessage(`⚠️ ${t('Tara-UpgradeRequired')}`)
        );
        store.dispatch(setIsPaymentPopupOpen(true));
      } else if (response?.data?.status === 'custom_openai_key_required') {
        store.dispatch(
          setMessage({
            message: t('Tara-CustomOpenAIKey-error'),
            messageType: 'warning',
          })
        );
        if (navigate) {
          navigate('/settings/general');
        }
      } else if (response?.data?.status === 'no_integrations_found') {
        if (toggleNoIntegrationsPopupModal) {
          toggleNoIntegrationsPopupModal();
        }
      }
    }
  }
  return false;
}
